import { Game } from '../srm/srm-parser'

const BOSS_ITEMS: [string, keyof Game['bosses']][] = [
  ['Kraid', 'kraid'],
  ['Phantoon', 'phantoon'],
  ['Draygon', 'draygon'],
  ['Ridley', 'ridley'],
  ['Silver Torizo', 'silverTorizo'],
  ['Golden Torizo', 'goldenTorizo'],
  ['Spore Spawn', 'sporeSpawn'],
  ['Crocomire', 'crocomire'],
  ['Botwoon', 'botwoon']
]

function BossesSection({
  bosses,
  onUpdate
}: {
  bosses: Game['bosses']
  onUpdate: (key: keyof Game['bosses'], value: boolean) => void
}) {
  return (
    <div className="card-section">
      <h3 className="section-title">Bosses Defeated</h3>
      <div className="check-grid">
        {BOSS_ITEMS.map(([name, key]) => (
          <label key={key} className="check-label">
            <input
              type="checkbox"
              checked={bosses[key]}
              onChange={(e) => onUpdate(key, e.target.checked)}
            />
            <span>{name}</span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default BossesSection
